var _path, _path2, _g, _path3, _g2, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndividualM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2765 34C26.2658 34 33.5531 26.6127 33.5531 17.5C33.5531 8.3873 26.2658 1 17.2765 1C8.28726 1 1 8.3873 1 17.5C1 26.6127 8.28726 34 17.2765 34Z",
    fill: "#FFC3A6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2313_33280",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 33,
    height: 33
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2765 34C26.2658 34 33.5531 26.6127 33.5531 17.5C33.5531 8.3873 26.2658 1 17.2765 1C8.28726 1 1 8.3873 1 17.5C1 26.6127 8.28726 34 17.2765 34Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2313_33280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 9.05041C16.6666 9.05041 17.6547 7.87826 19.1174 9.03028C19.1174 9.03028 20.9663 9.13071 21.4241 10.9778C21.4241 10.9778 22.7476 11.7086 22.7017 13.3509C22.7017 13.3509 23.5598 13.864 22.6919 16.2909C22.6919 16.2909 24.4469 17.7206 23.703 19.833C23.703 19.833 26.3925 20.7427 25.4005 24.6801C25.4005 24.6801 30.0645 30.8048 24.609 33.7408L11.1748 34.6969C4.42763 31.5372 8.43991 26.2428 8.43991 26.2428C7.01071 24.3118 9.09386 22.6788 9.09386 22.6788C7.58023 20.4593 10.4112 19.1713 10.4112 19.1713C9.08784 16.7769 10.5826 15.0348 10.5826 15.0348C10.1314 12.8405 11.6803 11.994 11.6803 11.994C11.536 9.80826 13.505 9.86376 13.505 9.86376C15.1093 7.71624 16.6666 9.05041 16.6666 9.05041Z",
    fill: "#4E5175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4662 9.05041C16.4662 9.05041 17.4543 7.87826 18.917 9.03028C18.917 9.03028 20.7659 9.13071 21.2237 10.9778C21.2237 10.9778 22.5472 11.7086 22.5013 13.3509C22.5013 13.3509 23.3594 13.864 22.4915 16.2909C22.4915 16.2909 24.2465 17.7206 23.5026 19.833C23.5026 19.833 26.1921 20.7427 25.2001 24.6801C25.2001 24.6801 29.8641 30.8048 24.4088 33.7408L10.9746 34.6969C4.22744 31.5372 8.23972 26.2428 8.23972 26.2428C6.81051 24.3118 8.89366 22.6788 8.89366 22.6788C7.38003 20.4593 10.211 19.1713 10.211 19.1713C8.88744 16.7769 10.3824 15.0348 10.3824 15.0348C9.93123 12.8405 11.4801 11.994 11.4801 11.994C11.3358 9.80826 13.3048 9.86376 13.3048 9.86376C14.9089 7.71624 16.4662 9.05041 16.4662 9.05041Z",
    stroke: "#006D8D",
    strokeWidth: 0.6606,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7989 25.3957L28.8479 32.3241C28.8479 32.3241 29.5019 34.7141 28.0101 34.4777C28.0101 34.4777 21.887 29.8741 20.2231 27.3932C20.2231 27.3932 18.3696 25.3453 20.4658 24.2262C22.5622 23.1071 23.7989 25.3957 23.7989 25.3957Z",
    fill: "#006D8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2654 31.1417C26.018 30.1993 25.8381 29.2619 25.7336 28.3241C25.6442 28.0991 25.5501 27.8765 25.4477 27.6584L23.7987 25.3956C23.7987 25.3956 22.562 23.1072 20.4658 24.2261C18.3696 25.345 20.2231 27.3931 20.2231 27.3931C21.4927 29.2861 25.3562 32.4133 27.1171 33.7897C26.7469 32.9339 26.4936 32.011 26.2654 31.1417Z",
    fill: "#006D8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5889 24.4603C13.9945 24.2712 15.4232 23.3989 15.8359 23.3213C16.1663 21.9814 14.448 20.1055 14.448 20.1055L18.4366 22.1202C18.2922 22.9781 18.4795 23.5221 18.4795 23.5221L20.1646 23.7169C20.1646 23.7169 21.6237 26.0878 18.9612 26.0396C18.205 26.026 17.5502 25.8093 16.9947 25.5103C15.9353 25.3464 13.5889 24.4603 13.5889 24.4603Z",
    fill: "#D3A082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5648 16.6939C12.1173 18.7335 13.4446 20.5263 15.5378 21.0618C16.5455 21.3195 17.6115 21.3039 18.6126 21.0213C21.8065 20.1195 23.2199 16.3622 22.3303 13.1244C21.5795 10.3914 19.1061 8.76878 16.3748 9.0914C14.7337 9.28513 13.2399 10.2453 12.2799 11.5955C11.7874 12.2883 11.8339 13.0844 11.6689 13.9229C11.4636 14.9642 11.2945 15.6962 11.5648 16.6939Z",
    fill: "#4E5175"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M18.392 23.0083C17.863 23.0835 16.8316 23.1301 15.7898 22.1893C15.2616 21.7122 14.9177 21.07 14.6123 20.416L18.5165 21.5008C18.488 22.0769 18.3037 22.6959 18.392 23.0083Z",
    fill: "url(#paint0_linear_2313_33280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4554 18.3331C22.4103 19.6598 21.8967 21.0488 20.8343 21.8783C19.5306 22.8961 18.392 22.42 16.9955 21.8854C13.9095 20.7041 11.7389 18.2632 12.0682 14.7293C12.6948 8.0035 22.7049 8.99635 22.601 15.2649C22.5892 15.9724 22.3826 16.7162 22.4352 17.4269C22.4578 17.7349 22.4654 18.0373 22.4554 18.3331Z",
    fill: "#ECC1A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2981 17.4597C17.2686 18.0247 17.7784 18.2863 18.1036 18.3038C18.4287 18.3213 18.7006 18.0615 18.7301 17.4965C18.7596 16.9316 18.52 16.4594 18.1947 16.4419C17.8694 16.4244 17.3274 16.8946 17.2981 17.4597Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.128 16.7306C18.3991 16.583 18.3125 16.7066 18.5652 16.5742C18.4753 16.4643 18.294 16.1896 18.1306 16.2036C17.8398 16.2286 17.7121 16.4447 17.5332 16.7751C17.6218 16.7104 18.0283 16.7848 18.128 16.7306Z",
    fill: "#EF9D84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0958 16.9673C21.072 17.4253 21.2563 17.5434 21.5075 17.5568C21.7588 17.5702 22.0871 17.3625 22.1109 16.9045C22.1348 16.4465 21.8452 16.1759 21.594 16.1625C21.3427 16.1491 21.1197 16.5095 21.0958 16.9673Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3418 16.8636C18.2468 16.8585 18.1579 16.916 18.0855 17.0116L18.1866 17.2128L17.9941 17.1775C17.9554 17.2748 17.9289 17.3879 17.9225 17.5111C17.9032 17.88 18.0597 18.1884 18.272 18.1996C18.4844 18.211 18.6721 17.9211 18.6913 17.5521C18.7106 17.1834 18.5542 16.875 18.3418 16.8636Z",
    fill: "#13162C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7833 16.4143C21.7055 16.4101 21.6325 16.4572 21.5734 16.5355L21.6562 16.7004L21.4986 16.6713C21.4669 16.751 21.4452 16.8437 21.4398 16.9447C21.424 17.247 21.5523 17.4997 21.7262 17.509C21.9002 17.5184 22.054 17.2807 22.0699 16.9785C22.0857 16.6762 21.9574 16.4235 21.7833 16.4143Z",
    fill: "#13162C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3879 16.3361C21.711 16.3414 21.6763 16.2453 21.9273 16.2325C21.8435 16.115 21.7188 15.933 21.5838 15.9263C21.4043 15.9174 21.3522 16.0227 21.2227 16.3445C21.2936 16.2851 21.2965 16.3347 21.3879 16.3361Z",
    fill: "#EF9D84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5318 16.7682C17.6481 16.7086 17.7643 16.6753 17.8808 16.6466C17.9967 16.6165 18.1174 16.6198 18.2351 16.6017C18.3526 16.5844 18.4695 16.562 18.5808 16.5254C18.6877 16.4905 18.8145 16.4459 18.8453 16.3301L18.8455 16.3291C18.8469 16.3242 18.8517 16.3213 18.8566 16.3225C18.8606 16.3236 18.8634 16.3274 18.8632 16.3315C18.8628 16.3984 18.8207 16.4592 18.7735 16.5018C18.7256 16.5458 18.6711 16.5801 18.6155 16.61C18.5028 16.6671 18.3849 16.7084 18.2664 16.7448C18.1477 16.7795 18.0296 16.8241 17.9058 16.8281C17.7825 16.833 17.6582 16.8273 17.533 16.7862C17.528 16.7846 17.5252 16.7789 17.5268 16.7738C17.5274 16.7714 17.5294 16.7694 17.5318 16.7682Z",
    fill: "#24181A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1894 16.3101C21.2845 16.2617 21.3763 16.24 21.468 16.2225C21.559 16.204 21.6523 16.2193 21.7435 16.2117C21.8348 16.206 21.9264 16.1951 22.009 16.1662C22.0902 16.1418 22.1761 16.093 22.1717 15.9944L22.1715 15.992C22.1713 15.9869 22.1751 15.9826 22.1801 15.9824C22.1849 15.9822 22.1891 15.9859 22.1895 15.9908C22.1913 16.0152 22.1993 16.0424 22.1947 16.0684C22.1863 16.0928 22.1829 16.1241 22.164 16.1432C22.1344 16.1898 22.0906 16.2223 22.0471 16.2491C21.9577 16.301 21.8622 16.3313 21.767 16.3563C21.6717 16.3807 21.5761 16.4134 21.478 16.4055C21.3806 16.3988 21.2831 16.3809 21.1888 16.3282C21.1838 16.3254 21.1822 16.3193 21.1848 16.3142C21.1858 16.3126 21.1876 16.3109 21.1894 16.3101Z",
    fill: "#24181A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7391 15.8627C18.6968 15.8343 18.6089 15.7985 18.5343 15.78C18.4561 15.7576 18.3729 15.7491 18.2891 15.744C18.1206 15.7367 17.9474 15.766 17.7787 15.818C17.6081 15.8666 17.447 15.952 17.2878 16.0404L17.0576 16.1924L16.8382 16.3638L16.8348 16.3665C16.8092 16.3866 16.7723 16.3817 16.7524 16.3557C16.7339 16.3315 16.737 16.2971 16.7582 16.2764L16.965 16.0752L17.1886 15.8898C17.3468 15.7771 17.5104 15.6661 17.6955 15.5899C17.878 15.5106 18.0755 15.4533 18.2829 15.4391C18.3864 15.4334 18.4918 15.433 18.5975 15.4502C18.7066 15.4683 18.8009 15.487 18.9246 15.5478C19.0148 15.5921 19.0525 15.7023 19.0088 15.7938C18.9651 15.8853 18.8564 15.9235 18.7662 15.8792C18.7591 15.8757 18.7523 15.8719 18.7459 15.8676L18.7391 15.8627Z",
    fill: "#323656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0756 15.2841C21.2395 15.1794 21.3901 15.1511 21.5517 15.1371C21.7105 15.1269 21.8663 15.1507 22.0127 15.1924C22.1609 15.2314 22.2963 15.2995 22.4276 15.3691L22.6159 15.4874L22.793 15.6195C22.8126 15.6341 22.8169 15.662 22.8024 15.6819C22.789 15.7004 22.7641 15.7053 22.7449 15.6941L22.7419 15.6923L22.5582 15.5835L22.3683 15.4906C22.2383 15.439 22.1074 15.39 21.9726 15.3699C21.8391 15.3469 21.7041 15.3418 21.5762 15.3642C21.453 15.3841 21.3181 15.4384 21.2437 15.4998L21.234 15.5077C21.1757 15.5559 21.0899 15.5469 21.0423 15.488C20.9948 15.4288 21.0036 15.3418 21.0618 15.2936C21.0662 15.2904 21.0712 15.2869 21.0756 15.2841Z",
    fill: "#323656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0566 18.8252C21.2171 18.8329 20.7475 18.1269 20.7475 18.1269L20.3976 17.5156",
    stroke: "#DB8977",
    strokeWidth: 1.06,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1477 18.7295L17.4057 18.514C17.1793 18.4422 16.9365 18.5713 16.8659 18.8008L16.8535 18.8413C16.7829 19.0708 16.9102 19.3172 17.1366 19.3887L17.8782 19.604C18.1044 19.6758 18.3476 19.5467 18.4182 19.3172L18.4307 19.2769C18.5013 19.0474 18.3739 18.801 18.1477 18.7295Z",
    fill: "#EF9D84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7766 19.2632L22.3407 18.9461C22.5161 18.853 22.5845 18.6312 22.4925 18.4533L22.4762 18.422C22.3842 18.2441 22.1654 18.1748 21.9897 18.2681L21.4262 18.585C21.2508 18.6781 21.1824 18.8999 21.2742 19.078L21.2905 19.1093C21.3823 19.287 21.6011 19.3563 21.7766 19.2632Z",
    fill: "#EF9D84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5589 20.7405C18.6267 20.9871 18.8789 21.1314 19.1222 21.0627C19.3654 20.994 19.5078 20.7383 19.44 20.4917C19.3723 20.2451 19.12 20.1007 18.8767 20.1695C18.6333 20.238 18.4911 20.4937 18.5589 20.7405Z",
    fill: "#DD5563"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7973 20.4659C19.7973 20.4659 18.8622 20.9876 18.5498 20.1992",
    stroke: "#24181A",
    strokeWidth: 0.9025,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8291 20.7559C14.8291 20.7559 15.4024 21.235 15.8402 22.5432",
    stroke: "#080C3E",
    strokeWidth: 0.6784,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.715 14.5977L16.3712 15.8862C18.1238 14.938 19.7407 14.5945 19.7407 14.5945L19.6451 13.1481L20.2078 14.4625C22.5007 14.3818 23.2571 15.3019 23.2571 15.3019C23.7931 13.2237 21.6849 11.7787 21.6849 11.7787C21.6849 11.7787 20.3241 10.1232 14.4336 13.5996C14.4336 13.5996 14.5563 14.9935 14.7697 17.0181L15.933 16.123L15.715 14.5977Z",
    fill: "#4E5175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.661 15.2897C14.661 15.2897 15.1796 16.4157 14.5112 17.0286C13.8428 17.6415 14.5764 17.6464 14.8898 18.4063C15.2032 19.1662 15.0663 20.0001 15.0663 20.0001L13.892 18.5819L13.292 19.006C13.292 19.006 12.1874 18.8511 11.9871 17.7411C12.0581 18.1343 11.5864 13.3953 12.5117 11.6545C12.5117 11.6545 16.2264 8.80302 19.3613 9.93269C19.3613 9.93269 21.4577 11.0904 21.7553 12.1731C21.7553 12.1731 16.1315 12.1461 14.661 15.2897Z",
    fill: "#4E5175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1351 16.5586C14.2831 16.7113 14.4074 16.8603 14.5415 16.9757C14.6079 17.0335 14.6709 17.0839 14.7371 17.1243C14.8574 17.1943 14.927 17.2837 14.9948 17.3705C15.1263 17.546 15.2163 17.7344 15.2942 17.9273C15.3294 18.0255 15.3623 18.1237 15.3856 18.2256C15.4077 18.3268 15.4313 18.4311 15.4101 18.5396L15.382 18.5341C15.3639 18.3433 15.2607 18.1601 15.165 17.9905C15.0667 17.8202 14.9543 17.6547 14.8223 17.5242C14.7573 17.4614 14.6825 17.403 14.62 17.3868C14.5032 17.3435 14.4066 17.2654 14.3348 17.1774C14.194 16.9975 14.1134 16.7899 14.1084 16.569L14.1351 16.5586Z",
    fill: "#4E5175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0339 16.9512C14.1819 17.1038 14.3062 17.2528 14.4404 17.3681C14.5068 17.4258 14.5697 17.4763 14.6359 17.5167C14.7562 17.5866 14.8258 17.6761 14.8936 17.7629C15.0251 17.9383 15.1152 18.127 15.193 18.3197C15.2283 18.4179 15.2612 18.5163 15.2844 18.6179C15.3065 18.7192 15.3302 18.8234 15.3089 18.932L15.2806 18.9265C15.2626 18.7356 15.1593 18.5525 15.0637 18.3829C14.9654 18.2126 14.8529 18.0473 14.7209 17.9166C14.656 17.8538 14.5812 17.7954 14.5186 17.7792C14.4019 17.7359 14.3052 17.6578 14.2332 17.5698C14.0925 17.3899 14.0118 17.1823 14.0068 16.9613L14.0339 16.9512Z",
    fill: "#4E5175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2568 15.3016C23.2568 15.3016 23.881 11.4403 20.1309 11.7833",
    stroke: "#080C3E",
    strokeWidth: 0.6606,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4888 12.0879C18.4888 12.0879 14.5692 12.9559 14.1094 14.9947",
    stroke: "#080C3E",
    strokeWidth: 0.6606,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0732 16.7905L15.9329 16.1227L15.715 14.5977L16.3713 15.8861",
    stroke: "#080C3E",
    strokeWidth: 0.6606,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7666 12.5938C21.7666 12.5938 22.1472 13.1225 22.1316 13.9222",
    stroke: "#080C3E",
    strokeWidth: 0.6606,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8174 14.806L19.741 14.5948L19.6454 13.1484",
    stroke: "#080C3E",
    strokeWidth: 0.6606,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7021 14.4316C20.7021 14.4316 21.8566 14.6359 22.6929 14.824",
    stroke: "#080C3E",
    strokeWidth: 0.6606,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6062 15.9355L22.4951 17.4874",
    stroke: "#080C3E",
    strokeWidth: 0.6606,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7772 19.7113C14.7772 19.7113 14.6516 17.7319 13.1903 18.4338C12.2244 18.8979 13.4187 20.4185 14.0199 20.3179C14.6211 20.2173 14.7772 19.7113 14.7772 19.7113Z",
    fill: "#ECC1A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.292 19.0067C13.292 19.0067 13.6497 18.582 14.1056 19.1844",
    stroke: "#080C3E",
    strokeWidth: 0.6606,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7607 19.209C13.7607 19.209 13.6074 19.4045 13.8054 19.6952",
    stroke: "#080C3E",
    strokeWidth: 0.6606,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5262 18.7639C14.1851 18.2872 12.9105 17.8626 12.9317 18.8566C12.9317 18.8566 12.8475 19.62 13.4531 20.1156",
    stroke: "#080C3E",
    strokeWidth: 0.6606,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7004 20.3315C13.7407 20.4779 13.8903 20.5636 14.0347 20.5228C14.1791 20.4819 14.2637 20.3303 14.2234 20.1839C14.1831 20.0375 14.0335 19.9517 13.8891 19.9926C13.7447 20.0333 13.6603 20.1849 13.7004 20.3315Z",
    fill: "#6294E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.962 20.2578L13.5225 21.8705",
    stroke: "#080C3E",
    strokeWidth: 0.5237,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2862 15.0273C18.2862 15.0273 17.0662 15.3546 16.8867 15.5366",
    stroke: "#080C3E",
    strokeWidth: 0.6606,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.476 23.4395C15.688 23.6251 14.1402 24.064 12.8769 24.2841C11.8772 24.4583 10.1855 27.0482 10.2759 27.457C10.3664 27.8656 11.4523 29.398 12.1762 29.7044C12.9001 30.0109 14.0765 33.9949 14.0765 33.9949C14.71 34.8121 15.6821 40.5286 15.3202 41.1415L22.3108 41.3503C22.3108 41.3503 24.0302 34.3015 24.0302 32.8714C24.0302 32.8714 26.003 31.4508 24.103 28.5903C24.103 28.5903 23.298 28.0742 22.5601 24.794C22.3764 23.9773 22.4129 23.9029 18.6916 23.4728C18.6916 23.4728 19.4155 23.9837 19.5964 24.6986C19.777 25.4138 18.3234 26.6752 15.476 23.4395Z",
    fill: "#006D8D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.69,
    d: "M23.0385 41.6685C23.0385 41.6685 23.1021 41.4076 23.2051 40.975C23.1851 40.8917 23.1628 40.8088 23.1362 40.7264C22.621 39.1361 21.0169 38.723 19.5891 38.3663C18.6636 38.1349 17.5539 37.9003 16.9138 37.1146C16.1991 36.2372 16.403 34.9933 16.6581 33.9812C16.6792 33.8976 16.7598 33.8683 16.835 33.8801C18.1184 34.0818 19.4814 33.9911 20.764 33.8326C21.6382 33.7246 22.8484 33.6008 23.7031 33.0993C22.3635 33.4219 20.8461 33.1841 19.5113 33.269C18.3209 33.3447 16.9691 33.4888 15.8919 32.8389C14.9668 32.2807 14.6307 31.2258 14.5296 30.1939C14.4454 29.335 14.5479 28.4743 14.4857 27.6148C14.4488 27.1054 14.3885 26.1908 13.8023 25.9936C13.3122 25.8287 12.7026 26.2314 12.3095 26.4774C11.724 26.8435 11.1789 27.2751 10.6387 27.7071C11.0616 28.2655 11.6048 28.8406 12.0326 29.0218C12.8187 29.3545 14.0961 33.6811 14.0961 33.6811C14.7839 34.5687 15.8397 40.7762 15.4467 41.442L23.0385 41.6685Z",
    fill: "#006D8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6992 24.1243L15.8361 23.3203",
    stroke: "#080C3E",
    strokeWidth: 0.4735,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6909 23.4727C18.6909 23.4727 19.5889 24.112 19.5958 24.6983C19.6056 25.5322 18.7461 25.5409 18.1443 25.3905C17.1368 25.1386 16.2946 24.3712 15.6182 23.6117",
    stroke: "#080C3E",
    strokeWidth: 0.4735,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9434 23.5156L22.0532 23.9521C22.0532 23.9521 22.6665 24.3328 22.8427 25.9406C23.0158 27.5194 24.9965 29.1261 24.9241 30.7425",
    stroke: "#080C3E",
    strokeWidth: 0.4735,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8894 31.2715C24.8894 31.2715 24.9774 33.1474 22.334 32.9687",
    stroke: "#080C3E",
    strokeWidth: 0.4735,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7783 32.8789C19.7783 32.8789 18.3684 33.8614 16.3418 32.9682",
    stroke: "#080C3E",
    strokeWidth: 0.4735,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0298 32.873L23.3037 37.3462",
    stroke: "#080C3E",
    strokeWidth: 0.4735,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9941 30.7344C12.9941 30.7344 14.3159 34.6647 14.4921 35.4687C14.6684 36.2727 14.6684 36.2727 14.6684 36.2727",
    stroke: "#080C3E",
    strokeWidth: 0.4735,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.125 23.9395C22.125 23.9395 23.4377 24.0608 25.053 27.1187L27.986 31.2755",
    stroke: "#080C3E",
    strokeWidth: 0.4735,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2891 25.0176C12.2891 25.0176 14.2276 25.375 14.0514 26.9828",
    stroke: "#080C3E",
    strokeWidth: 0.4735,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7805 24.5098C19.7805 24.5098 20.0436 25.3585 19.3259 25.601C19.3259 25.601 17.7948 26.1102 16.3594 24.5581",
    stroke: "#080C3E",
    strokeWidth: 0.4735,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5665 28.7028L8.46734 34.528C8.46734 34.528 5.7886 36.3247 5.70117 34.7965C5.70117 34.7965 8.84434 27.7559 10.8844 25.5828C10.8844 25.5828 12.4668 23.3131 13.989 25.1532C15.5115 26.9934 13.5665 28.7028 13.5665 28.7028Z",
    fill: "#006D8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1908 28.9688C13.1908 28.9688 10.0135 32.8861 9.08887 33.6397",
    stroke: "#080C3E",
    strokeWidth: 0.4735,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7075 24.2188C13.7075 24.2188 11.8409 23.819 10.4748 26.0728L8.4707 29.3278",
    stroke: "#080C3E",
    strokeWidth: 0.4735,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4578 30.8555L6.2207 33.5366",
    stroke: "#080C3E",
    strokeWidth: 0.4735,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.416 17.7129C14.416 17.7129 15.1967 18.2404 15.0882 20.219L15.1532 21.9557",
    stroke: "#080C3E",
    strokeWidth: 0.6606,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1777 24.6797C14.3729 25.0753 14.8934 25.603 14.8283 26.5261",
    stroke: "#080C3E",
    strokeWidth: 0.4735,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4978 11.5251C12.4761 11.4696 12.4647 11.4051 12.4659 11.3301C12.492 9.89857 15.7007 10.9191 13.6085 11.6133C13.2857 11.7206 12.6476 11.907 12.4978 11.5251Z",
    fill: "#64698C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5402 14.0067C11.5105 13.9819 11.4838 13.9485 11.4611 13.9052C11.0298 13.077 13.1855 12.6337 12.2039 13.7013C12.0523 13.8664 11.7451 14.1776 11.5402 14.0067Z",
    fill: "#64698C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.74328 21.5223C9.7136 21.4975 9.68693 21.4641 9.66427 21.4208C9.23292 20.5927 11.3887 20.1493 10.407 21.217C10.2554 21.3818 9.94822 21.6931 9.74328 21.5223Z",
    fill: "#64698C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1984 18.5591C11.1689 18.5709 11.133 18.5656 11.0895 18.5396C10.2577 18.0393 10.4562 13.9748 11.1138 17.0659C11.2152 17.5433 11.4011 18.478 11.1984 18.5591Z",
    fill: "#64698C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4932 9.19751C17.4983 9.15868 17.5121 9.11822 17.5364 9.07594C18.0024 8.26726 19.5122 9.88888 18.0993 9.60753C17.8811 9.56423 17.4584 9.46401 17.4932 9.19751Z",
    fill: "#64698C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8145 10.1161C19.8171 10.0966 19.8239 10.0761 19.8364 10.0547C20.0718 9.64633 20.8344 10.4654 20.1207 10.3233C20.0104 10.3015 19.7969 10.2509 19.8145 10.1161Z",
    fill: "#64698C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7465 9.77526C14.7384 9.73704 14.7378 9.69415 14.7467 9.64617C14.9165 8.72569 16.8771 9.73663 15.4535 9.95435C15.2337 9.9879 14.8022 10.0381 14.7465 9.77526Z",
    fill: "#64698C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7751 12.0963C14.7703 12.0739 14.7701 12.0487 14.7753 12.0204C14.8752 11.4797 16.0269 12.0735 15.1907 12.2016C15.0613 12.2211 14.8078 12.2506 14.7751 12.0963Z",
    fill: "#64698C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3271 15.7951C12.3079 15.7831 12.2898 15.7658 12.2734 15.7423C11.9584 15.2942 13.1792 14.8653 12.6901 15.5648C12.6143 15.6729 12.4595 15.8785 12.3271 15.7951Z",
    fill: "#64698C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5147 21.5723C12.5147 21.5723 11.9942 22.7599 12.5147 23.0439C12.5147 23.0439 11.7018 23.1601 12.2895 23.7224",
    stroke: "#080C3E",
    strokeWidth: 0.6606,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9983 11.3837C18.9983 11.3837 18.9563 10.6226 16.9951 9.31445",
    stroke: "#080C3E",
    strokeWidth: 0.6606,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7676 20.6155C22.7676 20.6155 23.6281 20.5828 23.6122 21.2433C23.6122 21.2433 24.1452 21.3254 23.7037 21.9533",
    stroke: "#080C3E",
    strokeWidth: 0.6606,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7676 23.3203C22.7676 23.3203 23.7949 23.6011 23.6122 24.1916",
    stroke: "#080C3E",
    strokeWidth: 0.6606,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2313_33280",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 33,
    height: 33
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2765 34C26.2658 34 33.5531 26.6127 33.5531 17.5C33.5531 8.3873 26.2658 1 17.2765 1C8.28726 1 1 8.3873 1 17.5C1 26.6127 8.28726 34 17.2765 34Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2313_33280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 9.05041C16.6666 9.05041 17.6547 7.87826 19.1174 9.03028C19.1174 9.03028 20.9663 9.13071 21.4241 10.9778C21.4241 10.9778 22.7476 11.7086 22.7017 13.3509C22.7017 13.3509 23.5598 13.864 22.6919 16.2909C22.6919 16.2909 24.4469 17.7206 23.703 19.833C23.703 19.833 26.3925 20.7427 25.4005 24.6801C25.4005 24.6801 30.0645 30.8048 24.609 33.7408L11.1748 34.6969C4.42763 31.5372 8.43991 26.2428 8.43991 26.2428C7.01071 24.3118 9.09386 22.6788 9.09386 22.6788C7.58023 20.4593 10.4112 19.1713 10.4112 19.1713C9.08784 16.7769 10.5826 15.0348 10.5826 15.0348C10.1314 12.8405 11.6803 11.994 11.6803 11.994C11.536 9.80826 13.505 9.86376 13.505 9.86376C15.1093 7.71624 16.6666 9.05041 16.6666 9.05041Z",
    fill: "#4E5175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4662 9.05041C16.4662 9.05041 17.4543 7.87826 18.917 9.03028C18.917 9.03028 20.7659 9.13071 21.2237 10.9778C21.2237 10.9778 22.5472 11.7086 22.5013 13.3509C22.5013 13.3509 23.3594 13.864 22.4915 16.2909C22.4915 16.2909 24.2465 17.7206 23.5026 19.833C23.5026 19.833 26.1921 20.7427 25.2001 24.6801C25.2001 24.6801 29.8641 30.8048 24.4088 33.7408L10.9746 34.6969C4.22744 31.5372 8.23972 26.2428 8.23972 26.2428C6.81051 24.3118 8.89366 22.6788 8.89366 22.6788C7.38003 20.4593 10.211 19.1713 10.211 19.1713C8.88744 16.7769 10.3824 15.0348 10.3824 15.0348C9.93123 12.8405 11.4801 11.994 11.4801 11.994C11.3358 9.80826 13.3048 9.86376 13.3048 9.86376C14.9089 7.71624 16.4662 9.05041 16.4662 9.05041Z",
    stroke: "#006D8D",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7989 25.3957L28.8479 32.3241C28.8479 32.3241 29.5019 34.7141 28.0101 34.4777C28.0101 34.4777 21.887 29.8741 20.2231 27.3932C20.2231 27.3932 18.3696 25.3453 20.4658 24.2262C22.5622 23.1071 23.7989 25.3957 23.7989 25.3957Z",
    fill: "#006D8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2654 31.1417C26.018 30.1993 25.8381 29.2619 25.7336 28.3241C25.6442 28.0991 25.5501 27.8765 25.4477 27.6584L23.7987 25.3956C23.7987 25.3956 22.562 23.1072 20.4658 24.2261C18.3696 25.345 20.2231 27.3931 20.2231 27.3931C21.4927 29.2861 25.3562 32.4133 27.1171 33.7897C26.7469 32.9339 26.4936 32.011 26.2654 31.1417Z",
    fill: "#006D8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5889 24.4603C13.9945 24.2712 15.4232 23.3989 15.8359 23.3213C16.1663 21.9814 14.448 20.1055 14.448 20.1055L18.4366 22.1202C18.2922 22.9781 18.4795 23.5221 18.4795 23.5221L20.1646 23.7169C20.1646 23.7169 21.6237 26.0878 18.9612 26.0396C18.205 26.026 17.5502 25.8093 16.9947 25.5103C15.9353 25.3464 13.5889 24.4603 13.5889 24.4603Z",
    fill: "#D3A082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5648 16.6939C12.1173 18.7335 13.4446 20.5263 15.5378 21.0618C16.5455 21.3195 17.6115 21.3039 18.6126 21.0213C21.8065 20.1195 23.2199 16.3622 22.3303 13.1244C21.5795 10.3914 19.1061 8.76878 16.3748 9.0914C14.7337 9.28513 13.2399 10.2453 12.2799 11.5955C11.7874 12.2883 11.8339 13.0844 11.6689 13.9229C11.4636 14.9642 11.2945 15.6962 11.5648 16.6939Z",
    fill: "#4E5175"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M18.392 23.0083C17.863 23.0835 16.8316 23.1301 15.7898 22.1893C15.2616 21.7122 14.9177 21.07 14.6123 20.416L18.5165 21.5008C18.488 22.0769 18.3037 22.6959 18.392 23.0083Z",
    fill: "url(#paint1_linear_2313_33280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4554 18.3331C22.4103 19.6598 21.8967 21.0488 20.8343 21.8783C19.5306 22.8961 18.392 22.42 16.9955 21.8854C13.9095 20.7041 11.7389 18.2632 12.0682 14.7293C12.6948 8.0035 22.7049 8.99635 22.601 15.2649C22.5892 15.9724 22.3826 16.7162 22.4352 17.4269C22.4578 17.7349 22.4654 18.0373 22.4554 18.3331Z",
    fill: "#ECC1A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2981 17.4597C17.2686 18.0247 17.7784 18.2863 18.1036 18.3038C18.4287 18.3213 18.7006 18.0615 18.7301 17.4965C18.7596 16.9316 18.52 16.4594 18.1947 16.4419C17.8694 16.4244 17.3274 16.8946 17.2981 17.4597Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.128 16.7306C18.3991 16.583 18.3125 16.7066 18.5652 16.5742C18.4753 16.4643 18.294 16.1896 18.1306 16.2036C17.8398 16.2286 17.7121 16.4447 17.5332 16.7751C17.6218 16.7104 18.0283 16.7848 18.128 16.7306Z",
    fill: "#EF9D84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0958 16.9673C21.072 17.4253 21.2563 17.5434 21.5075 17.5568C21.7588 17.5702 22.0871 17.3625 22.1109 16.9045C22.1348 16.4465 21.8452 16.1759 21.594 16.1625C21.3427 16.1491 21.1197 16.5095 21.0958 16.9673Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3418 16.8636C18.2468 16.8585 18.1579 16.916 18.0855 17.0116L18.1866 17.2128L17.9941 17.1775C17.9554 17.2748 17.9289 17.3879 17.9225 17.5111C17.9032 17.88 18.0597 18.1884 18.272 18.1996C18.4844 18.211 18.6721 17.9211 18.6913 17.5521C18.7106 17.1834 18.5542 16.875 18.3418 16.8636Z",
    fill: "#13162C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7833 16.4143C21.7055 16.4101 21.6325 16.4572 21.5734 16.5355L21.6562 16.7004L21.4986 16.6713C21.4669 16.751 21.4452 16.8437 21.4398 16.9447C21.424 17.247 21.5523 17.4997 21.7262 17.509C21.9002 17.5184 22.054 17.2807 22.0699 16.9785C22.0857 16.6762 21.9574 16.4235 21.7833 16.4143Z",
    fill: "#13162C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3879 16.3361C21.711 16.3414 21.6763 16.2453 21.9273 16.2325C21.8435 16.115 21.7188 15.933 21.5838 15.9263C21.4043 15.9174 21.3522 16.0227 21.2227 16.3445C21.2936 16.2851 21.2965 16.3347 21.3879 16.3361Z",
    fill: "#EF9D84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5318 16.7682C17.6481 16.7086 17.7643 16.6753 17.8808 16.6466C17.9967 16.6165 18.1174 16.6198 18.2351 16.6017C18.3526 16.5844 18.4695 16.562 18.5808 16.5254C18.6877 16.4905 18.8145 16.4459 18.8453 16.3301L18.8455 16.3291C18.8469 16.3242 18.8517 16.3213 18.8566 16.3225C18.8606 16.3236 18.8634 16.3274 18.8632 16.3315C18.8628 16.3984 18.8207 16.4592 18.7735 16.5018C18.7256 16.5458 18.6711 16.5801 18.6155 16.61C18.5028 16.6671 18.3849 16.7084 18.2664 16.7448C18.1477 16.7795 18.0296 16.8241 17.9058 16.8281C17.7825 16.833 17.6582 16.8273 17.533 16.7862C17.528 16.7846 17.5252 16.7789 17.5268 16.7738C17.5274 16.7714 17.5294 16.7694 17.5318 16.7682Z",
    fill: "#24181A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1894 16.3101C21.2845 16.2617 21.3763 16.24 21.468 16.2225C21.559 16.204 21.6523 16.2193 21.7435 16.2117C21.8348 16.206 21.9264 16.1951 22.009 16.1662C22.0902 16.1418 22.1761 16.093 22.1717 15.9944L22.1715 15.992C22.1713 15.9869 22.1751 15.9826 22.1801 15.9824C22.1849 15.9822 22.1891 15.9859 22.1895 15.9908C22.1913 16.0152 22.1993 16.0424 22.1947 16.0684C22.1863 16.0928 22.1829 16.1241 22.164 16.1432C22.1344 16.1898 22.0906 16.2223 22.0471 16.2491C21.9577 16.301 21.8622 16.3313 21.767 16.3563C21.6717 16.3807 21.5761 16.4134 21.478 16.4055C21.3806 16.3988 21.2831 16.3809 21.1888 16.3282C21.1838 16.3254 21.1822 16.3193 21.1848 16.3142C21.1858 16.3126 21.1876 16.3109 21.1894 16.3101Z",
    fill: "#24181A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7391 15.8627C18.6968 15.8343 18.6089 15.7985 18.5343 15.78C18.4561 15.7576 18.3729 15.7491 18.2891 15.744C18.1206 15.7367 17.9474 15.766 17.7787 15.818C17.6081 15.8666 17.447 15.952 17.2878 16.0404L17.0576 16.1924L16.8382 16.3638L16.8348 16.3665C16.8092 16.3866 16.7723 16.3817 16.7524 16.3557C16.7339 16.3315 16.737 16.2971 16.7582 16.2764L16.965 16.0752L17.1886 15.8898C17.3468 15.7771 17.5104 15.6661 17.6955 15.5899C17.878 15.5106 18.0755 15.4533 18.2829 15.4391C18.3864 15.4334 18.4918 15.433 18.5975 15.4502C18.7066 15.4683 18.8009 15.487 18.9246 15.5478C19.0148 15.5921 19.0525 15.7023 19.0088 15.7938C18.9651 15.8853 18.8564 15.9235 18.7662 15.8792C18.7591 15.8757 18.7523 15.8719 18.7459 15.8676L18.7391 15.8627Z",
    fill: "#323656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0756 15.2841C21.2395 15.1794 21.3901 15.1511 21.5517 15.1371C21.7105 15.1269 21.8663 15.1507 22.0127 15.1924C22.1609 15.2314 22.2963 15.2995 22.4276 15.3691L22.6159 15.4874L22.793 15.6195C22.8126 15.6341 22.8169 15.662 22.8024 15.6819C22.789 15.7004 22.7641 15.7053 22.7449 15.6941L22.7419 15.6923L22.5582 15.5835L22.3683 15.4906C22.2383 15.439 22.1074 15.39 21.9726 15.3699C21.8391 15.3469 21.7041 15.3418 21.5762 15.3642C21.453 15.3841 21.3181 15.4384 21.2437 15.4998L21.234 15.5077C21.1757 15.5559 21.0899 15.5469 21.0423 15.488C20.9948 15.4288 21.0036 15.3418 21.0618 15.2936C21.0662 15.2904 21.0712 15.2869 21.0756 15.2841Z",
    fill: "#323656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0566 18.8252C21.2171 18.8329 20.7475 18.1269 20.7475 18.1269L20.3976 17.5156",
    stroke: "#DB8977",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1477 18.7295L17.4057 18.514C17.1793 18.4422 16.9365 18.5713 16.8659 18.8008L16.8535 18.8413C16.7829 19.0708 16.9102 19.3172 17.1366 19.3887L17.8782 19.604C18.1044 19.6758 18.3476 19.5467 18.4182 19.3172L18.4307 19.2769C18.5013 19.0474 18.3739 18.801 18.1477 18.7295Z",
    fill: "#EF9D84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7766 19.2632L22.3407 18.9461C22.5161 18.853 22.5845 18.6312 22.4925 18.4533L22.4762 18.422C22.3842 18.2441 22.1654 18.1748 21.9897 18.2681L21.4262 18.585C21.2508 18.6781 21.1824 18.8999 21.2742 19.078L21.2905 19.1093C21.3823 19.287 21.6011 19.3563 21.7766 19.2632Z",
    fill: "#EF9D84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5589 20.7405C18.6267 20.9871 18.8789 21.1314 19.1222 21.0627C19.3654 20.994 19.5078 20.7383 19.44 20.4917C19.3723 20.2451 19.12 20.1007 18.8767 20.1695C18.6333 20.238 18.4911 20.4937 18.5589 20.7405Z",
    fill: "#DD5563"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7973 20.4659C19.7973 20.4659 18.8622 20.9876 18.5498 20.1992",
    stroke: "#24181A",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8291 20.7559C14.8291 20.7559 15.4024 21.235 15.8402 22.5432",
    stroke: "#080C3E",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.715 14.5977L16.3712 15.8862C18.1238 14.938 19.7407 14.5945 19.7407 14.5945L19.6451 13.1481L20.2078 14.4625C22.5007 14.3818 23.2571 15.3019 23.2571 15.3019C23.7931 13.2237 21.6849 11.7787 21.6849 11.7787C21.6849 11.7787 20.3241 10.1232 14.4336 13.5996C14.4336 13.5996 14.5563 14.9935 14.7697 17.0181L15.933 16.123L15.715 14.5977Z",
    fill: "#4E5175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.661 15.2897C14.661 15.2897 15.1796 16.4157 14.5112 17.0286C13.8428 17.6415 14.5764 17.6464 14.8898 18.4063C15.2032 19.1662 15.0663 20.0001 15.0663 20.0001L13.892 18.5819L13.292 19.006C13.292 19.006 12.1874 18.8511 11.9871 17.7411C12.0581 18.1343 11.5864 13.3953 12.5117 11.6545C12.5117 11.6545 16.2264 8.80302 19.3613 9.93269C19.3613 9.93269 21.4577 11.0904 21.7553 12.1731C21.7553 12.1731 16.1315 12.1461 14.661 15.2897Z",
    fill: "#4E5175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1351 16.5586C14.2831 16.7113 14.4074 16.8603 14.5415 16.9757C14.6079 17.0335 14.6709 17.0839 14.7371 17.1243C14.8574 17.1943 14.927 17.2837 14.9948 17.3705C15.1263 17.546 15.2163 17.7344 15.2942 17.9273C15.3294 18.0255 15.3623 18.1237 15.3856 18.2256C15.4077 18.3268 15.4313 18.4311 15.4101 18.5396L15.382 18.5341C15.3639 18.3433 15.2607 18.1601 15.165 17.9905C15.0667 17.8202 14.9543 17.6547 14.8223 17.5242C14.7573 17.4614 14.6825 17.403 14.62 17.3868C14.5032 17.3435 14.4066 17.2654 14.3348 17.1774C14.194 16.9975 14.1134 16.7899 14.1084 16.569L14.1351 16.5586Z",
    fill: "#4E5175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0339 16.9512C14.1819 17.1038 14.3062 17.2528 14.4404 17.3681C14.5068 17.4258 14.5697 17.4763 14.6359 17.5167C14.7562 17.5866 14.8258 17.6761 14.8936 17.7629C15.0251 17.9383 15.1152 18.127 15.193 18.3197C15.2283 18.4179 15.2612 18.5163 15.2844 18.6179C15.3065 18.7192 15.3302 18.8234 15.3089 18.932L15.2806 18.9265C15.2626 18.7356 15.1593 18.5525 15.0637 18.3829C14.9654 18.2126 14.8529 18.0473 14.7209 17.9166C14.656 17.8538 14.5812 17.7954 14.5186 17.7792C14.4019 17.7359 14.3052 17.6578 14.2332 17.5698C14.0925 17.3899 14.0118 17.1823 14.0068 16.9613L14.0339 16.9512Z",
    fill: "#4E5175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2568 15.3016C23.2568 15.3016 23.881 11.4403 20.1309 11.7833",
    stroke: "#080C3E",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4888 12.0879C18.4888 12.0879 14.5692 12.9559 14.1094 14.9947",
    stroke: "#080C3E",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0732 16.7905L15.9329 16.1227L15.715 14.5977L16.3713 15.8861",
    stroke: "#080C3E",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7666 12.5938C21.7666 12.5938 22.1472 13.1225 22.1316 13.9222",
    stroke: "#080C3E",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8174 14.806L19.741 14.5948L19.6454 13.1484",
    stroke: "#080C3E",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7021 14.4316C20.7021 14.4316 21.8566 14.6359 22.6929 14.824",
    stroke: "#080C3E",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6062 15.9355L22.4951 17.4874",
    stroke: "#080C3E",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7772 19.7113C14.7772 19.7113 14.6516 17.7319 13.1903 18.4338C12.2244 18.8979 13.4187 20.4185 14.0199 20.3179C14.6211 20.2173 14.7772 19.7113 14.7772 19.7113Z",
    fill: "#ECC1A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.292 19.0067C13.292 19.0067 13.6497 18.582 14.1056 19.1844",
    stroke: "#080C3E",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7607 19.209C13.7607 19.209 13.6074 19.4045 13.8054 19.6952",
    stroke: "#080C3E",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5262 18.7639C14.1851 18.2872 12.9105 17.8626 12.9317 18.8566C12.9317 18.8566 12.8475 19.62 13.4531 20.1156",
    stroke: "#080C3E",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7004 20.3315C13.7407 20.4779 13.8903 20.5636 14.0347 20.5228C14.1791 20.4819 14.2637 20.3303 14.2234 20.1839C14.1831 20.0375 14.0335 19.9517 13.8891 19.9926C13.7447 20.0333 13.6603 20.1849 13.7004 20.3315Z",
    fill: "#6294E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.962 20.2578L13.5225 21.8705",
    stroke: "#080C3E",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2862 15.0273C18.2862 15.0273 17.0662 15.3546 16.8867 15.5366",
    stroke: "#080C3E",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.476 23.4395C15.688 23.6251 14.1402 24.064 12.8769 24.2841C11.8772 24.4583 10.1855 27.0482 10.2759 27.457C10.3664 27.8656 11.4523 29.398 12.1762 29.7044C12.9001 30.0109 14.0765 33.9949 14.0765 33.9949C14.71 34.8121 15.6821 40.5286 15.3202 41.1415L22.3108 41.3503C22.3108 41.3503 24.0302 34.3015 24.0302 32.8714C24.0302 32.8714 26.003 31.4508 24.103 28.5903C24.103 28.5903 23.298 28.0742 22.5601 24.794C22.3764 23.9773 22.4129 23.9029 18.6916 23.4728C18.6916 23.4728 19.4155 23.9837 19.5964 24.6986C19.777 25.4138 18.3234 26.6752 15.476 23.4395Z",
    fill: "#006D8D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.69,
    d: "M23.0385 41.6685C23.0385 41.6685 23.1021 41.4076 23.2051 40.975C23.1851 40.8917 23.1628 40.8088 23.1362 40.7264C22.621 39.1361 21.0169 38.723 19.5891 38.3663C18.6636 38.1349 17.5539 37.9003 16.9138 37.1146C16.1991 36.2372 16.403 34.9933 16.6581 33.9812C16.6792 33.8976 16.7598 33.8683 16.835 33.8801C18.1184 34.0818 19.4814 33.9911 20.764 33.8326C21.6382 33.7246 22.8484 33.6008 23.7031 33.0993C22.3635 33.4219 20.8461 33.1841 19.5113 33.269C18.3209 33.3447 16.9691 33.4888 15.8919 32.8389C14.9668 32.2807 14.6307 31.2258 14.5296 30.1939C14.4454 29.335 14.5479 28.4743 14.4857 27.6148C14.4488 27.1054 14.3885 26.1908 13.8023 25.9936C13.3122 25.8287 12.7026 26.2314 12.3095 26.4774C11.724 26.8435 11.1789 27.2751 10.6387 27.7071C11.0616 28.2655 11.6048 28.8406 12.0326 29.0218C12.8187 29.3545 14.0961 33.6811 14.0961 33.6811C14.7839 34.5687 15.8397 40.7762 15.4467 41.442L23.0385 41.6685Z",
    fill: "#006D8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6992 24.1243L15.8361 23.3203",
    stroke: "#080C3E",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6909 23.4727C18.6909 23.4727 19.5889 24.112 19.5958 24.6983C19.6056 25.5322 18.7461 25.5409 18.1443 25.3905C17.1368 25.1386 16.2946 24.3712 15.6182 23.6117",
    stroke: "#080C3E",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9434 23.5156L22.0532 23.9521C22.0532 23.9521 22.6665 24.3328 22.8427 25.9406C23.0158 27.5194 24.9965 29.1261 24.9241 30.7425",
    stroke: "#080C3E",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8894 31.2715C24.8894 31.2715 24.9774 33.1474 22.334 32.9687",
    stroke: "#080C3E",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7783 32.8789C19.7783 32.8789 18.3684 33.8614 16.3418 32.9682",
    stroke: "#080C3E",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0298 32.873L23.3037 37.3462",
    stroke: "#080C3E",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9941 30.7344C12.9941 30.7344 14.3159 34.6647 14.4921 35.4687C14.6684 36.2727 14.6684 36.2727 14.6684 36.2727",
    stroke: "#080C3E",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.125 23.9395C22.125 23.9395 23.4377 24.0608 25.053 27.1187L27.986 31.2755",
    stroke: "#080C3E",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2891 25.0176C12.2891 25.0176 14.2276 25.375 14.0514 26.9828",
    stroke: "#080C3E",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7805 24.5098C19.7805 24.5098 20.0436 25.3585 19.3259 25.601C19.3259 25.601 17.7948 26.1102 16.3594 24.5581",
    stroke: "#080C3E",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5665 28.7028L8.46734 34.528C8.46734 34.528 5.7886 36.3247 5.70117 34.7965C5.70117 34.7965 8.84434 27.7559 10.8844 25.5828C10.8844 25.5828 12.4668 23.3131 13.989 25.1532C15.5115 26.9934 13.5665 28.7028 13.5665 28.7028Z",
    fill: "#006D8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1908 28.9688C13.1908 28.9688 10.0135 32.8861 9.08887 33.6397",
    stroke: "#080C3E",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7075 24.2188C13.7075 24.2188 11.8409 23.819 10.4748 26.0728L8.4707 29.3278",
    stroke: "#080C3E",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4578 30.8555L6.2207 33.5366",
    stroke: "#080C3E",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.416 17.7129C14.416 17.7129 15.1967 18.2404 15.0882 20.219L15.1532 21.9557",
    stroke: "#080C3E",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1777 24.6797C14.3729 25.0753 14.8934 25.603 14.8283 26.5261",
    stroke: "#080C3E",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4978 11.5251C12.4761 11.4696 12.4647 11.4051 12.4659 11.3301C12.492 9.89857 15.7007 10.9191 13.6085 11.6133C13.2857 11.7206 12.6476 11.907 12.4978 11.5251Z",
    fill: "#64698C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5402 14.0067C11.5105 13.9819 11.4838 13.9485 11.4611 13.9052C11.0298 13.077 13.1855 12.6337 12.2039 13.7013C12.0523 13.8664 11.7451 14.1776 11.5402 14.0067Z",
    fill: "#64698C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.74328 21.5223C9.7136 21.4975 9.68693 21.4641 9.66427 21.4208C9.23292 20.5927 11.3887 20.1493 10.407 21.217C10.2554 21.3818 9.94822 21.6931 9.74328 21.5223Z",
    fill: "#64698C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1984 18.5591C11.1689 18.5709 11.133 18.5656 11.0895 18.5396C10.2577 18.0393 10.4562 13.9748 11.1138 17.0659C11.2152 17.5433 11.4011 18.478 11.1984 18.5591Z",
    fill: "#64698C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4932 9.19751C17.4983 9.15868 17.5121 9.11822 17.5364 9.07594C18.0024 8.26726 19.5122 9.88888 18.0993 9.60753C17.8811 9.56423 17.4584 9.46401 17.4932 9.19751Z",
    fill: "#64698C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8145 10.1161C19.8171 10.0966 19.8239 10.0761 19.8364 10.0547C20.0718 9.64633 20.8344 10.4654 20.1207 10.3233C20.0104 10.3015 19.7969 10.2509 19.8145 10.1161Z",
    fill: "#64698C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7465 9.77526C14.7384 9.73704 14.7378 9.69415 14.7467 9.64617C14.9165 8.72569 16.8771 9.73663 15.4535 9.95435C15.2337 9.9879 14.8022 10.0381 14.7465 9.77526Z",
    fill: "#64698C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7751 12.0963C14.7703 12.0739 14.7701 12.0487 14.7753 12.0204C14.8752 11.4797 16.0269 12.0735 15.1907 12.2016C15.0613 12.2211 14.8078 12.2506 14.7751 12.0963Z",
    fill: "#64698C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3271 15.7951C12.3079 15.7831 12.2898 15.7658 12.2734 15.7423C11.9584 15.2942 13.1792 14.8653 12.6901 15.5648C12.6143 15.6729 12.4595 15.8785 12.3271 15.7951Z",
    fill: "#64698C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5147 21.5723C12.5147 21.5723 11.9942 22.7599 12.5147 23.0439C12.5147 23.0439 11.7018 23.1601 12.2895 23.7224",
    stroke: "#080C3E",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9983 11.3837C18.9983 11.3837 18.9563 10.6226 16.9951 9.31445",
    stroke: "#080C3E",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7676 20.6155C22.7676 20.6155 23.6281 20.5828 23.6122 21.2433C23.6122 21.2433 24.1452 21.3254 23.7037 21.9533",
    stroke: "#080C3E",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7676 23.3203C22.7676 23.3203 23.7949 23.6011 23.6122 24.1916",
    stroke: "#080C3E",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2765 34C26.2658 34 33.5531 26.6127 33.5531 17.5C33.5531 8.3873 26.2658 1 17.2765 1C8.28726 1 1 8.3873 1 17.5C1 26.6127 8.28726 34 17.2765 34Z",
    stroke: "#080C3E",
    strokeWidth: 0.5705,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2313_33280",
    x1: 18.4255,
    y1: 21.1691,
    x2: 15.0724,
    y2: 22.0904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD835A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD835A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2313_33280",
    x1: 18.4255,
    y1: 21.1691,
    x2: 15.0724,
    y2: 22.0904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD835A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD835A",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndividualM);
export default __webpack_public_path__ + "static/media/IndividualM.bb63c0f0a19bf5858ff82df8a07b64d7.svg";
export { ForwardRef as ReactComponent };